var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.b()},[_c('v-expansion-panels',{attrs:{"accordion":""}},_vm._l((_vm.groups),function(gCredits,gTitle){return _c('credits-group',{key:gTitle,staticClass:"py-2",attrs:{"credits":gCredits,"title":gTitle}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }